import React from 'react';
import { Tooltip } from 'antd';

type TextWithEllipsisProps = {
  value: string | null | undefined;
  maxLength: number;
};

const TextWithEllipsis: React.FC<TextWithEllipsisProps> = ({ value, maxLength }) => {
  if (value && value.length > maxLength) {
    return <Tooltip title={value}>{value.slice(0, maxLength)}…</Tooltip>;
  }
  return <>{value}</>;
};
export default TextWithEllipsis;
